<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="right menu"></div>
      <a href="#" class="red item" @click.prevent="addVoucher"><i class="plus icon"></i> Add Voucher</a>
    </div>
    <div class="ui container">
      <h3 class="ui header">
        Vouchers
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <table class="ui table">
        <thead>
        <tr>
          <th>
            Code
          </th>
          <th>
            Deduct
          </th>
          <th>
            Conditions
          </th>
          <th class="collapsing">
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="voucher in vouchers">
          <td>{{ voucher.code }}</td>
          <td>Relative: <strong>-{{ voucher.deduct.percentage * 100 }}%</strong>, Absolute: <strong>-{{ voucher.deduct.absolute }}€</strong></td>
          <td>Min Total: <strong>{{ voucher.min.absolute }}€</strong>, Min Hours: <strong>{{ voucher.min.hours }}</strong></td>
          <td class="collapsing">
            <div class="ui tiny buttons">
              <div class="ui button" @click="editVoucher(voucher)"><i class="edit icon"></i> Edit Voucher</div>
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="editVoucher(voucher)"><i class="edit icon"></i> Edit Voucher</div>
                  <div class="item" @click="triggerDeleteVoucher(voucher)"><i class="trash icon"></i> Delete Voucher</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="ui small basic delete modal">
      <div class="header" style="text-align: center">
        Are you sure?
      </div>
      <div class="content" style="text-align: center">
        Delete voucher <strong v-if="voucherForDelete">{{ voucherForDelete.name }}</strong>
      </div>
      <div class="actions" style="text-align: center">
        <div class="ui red basic cancel inverted button">
          <i class="remove icon"></i>
          No
        </div>
        <div class="ui green ok inverted button" @click="deleteVoucher(voucherForDelete)">
          <i class="checkmark icon"></i>
          Yes
        </div>
      </div>
    </div>

    <div class="ui small modal" id="voucherModal">
      <i class="close icon"></i>
      <div class="header">
        <span v-if="voucher._id">Edit Voucher</span>
        <span v-else>Add Voucher</span>
      </div>
      <div class="content">
        <form class="ui form" @submit.prevent>
          <div class="ui field">
            <label>Code</label>
            <input class="ui input" v-model="voucher.code">
          </div>
          <div class="ui two fields">
            <div class="ui field">
              <label>Deduct %</label>
              <div class="ui right labeled input">
                <input class="ui input" type="number" v-model="voucher.deduct.percentage">
                <div class="ui basic label">%</div>
              </div>
            </div>
            <div class="ui field">
              <label>Deduct Absolute</label>
              <div class="ui right labeled input">
                <input class="ui input" type="number" v-model="voucher.deduct.absolute">
                <div class="ui basic label">€</div>
              </div>
            </div>
          </div>
          <div class="ui two fields">
            <div class="ui field">
              <label>Minimum Price</label>
              <div class="ui right labeled input">
                <input class="ui input" type="number" v-model="voucher.min.absolute">
                <div class="ui basic label">€</div>
              </div>
            </div>
            <div class="ui field">
              <label>Minimum Hours</label>
              <input class="ui input" type="number" v-model="voucher.min.hours">
            </div>
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui icon cancel button">
          <i class="delete icon"></i> Close
        </div>
        <div class="ui icon positive button" @click="saveVoucher">
          <i class="checkmark icon"></i> Save Voucher
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
        'vouchers': [],
        'settings': {},
        'voucher': {
          code: null,
          deduct: {
            percentage: null,
            absolute: null
          },
          min: {
            absolute: null,
            hours: null
          },
          status: 'active'
        },
        'voucherForDelete': null,
        'fetching': false,
        'moment': moment
      }
    },
    mounted() {
      this.fetchVouchers()

      services.voucherService.on('created', () => {
        this.fetchVouchers()
      })
      services.voucherService.on('patched', () => {
        this.fetchVouchers()
      })
      services.voucherService.on('removed', () => {
        this.fetchVouchers()
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    beforeDestroy() {
      $('.ui.modals').remove()
    },
    methods: {
      fetchVouchers() {
        this.fetching = true

        services.voucherService.find().then(vouchers => {
          this.vouchers = vouchers.data
          this.fetching = false
          this.initDropdown()
        })
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        console.log('open reservation')
        this.editReservation = reservation
        $('#reservationModal').modal({}).modal('show')
      },
      showVoucherModal() {
        $('#voucherModal').modal('show')
      },
      editVoucher(voucher) {
        this.voucher = voucher
        this.voucher.deduct.percentage = this.voucher.deduct.percentage * 100
        this.showVoucherModal()
      },
      addVoucher() {
        this.voucher = {
          code: null,
          deduct: {
            percentage: null,
            absolute: null
          },
          min: {
            absolute: null,
            hours: null
          },
          status: 'active'
        }
        this.showVoucherModal()
      },
      saveVoucher() {
        this.voucher.deduct.percentage = this.voucher.deduct.percentage / 100

        if (this.voucher._id) {
          services.voucherService.patch(this.voucher._id, this.voucher).then(voucher => {
            toastr.success('Voucher saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        } else {
          services.voucherService.create(this.voucher).then(voucher => {
            toastr.success('Voucher saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        }
      },
      triggerDeleteVoucher(voucher) {
        this.voucherForDelete = voucher

        $('.ui.delete.modal').modal('show')
      },
      deleteVoucher(voucher) {
        services.voucherService.remove(voucher._id).then(voucher => {
          toastr.info(`Removed voucher <strong>${voucher.name}</strong>`, 'Voucher removed!')
        })
      }
    },
    components: {}
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }

  .red.item {
    color: #771d14;
  }

  .calendar.item {
    padding: 4px 1px 0;
  }

  .text.input input {
    border: none;
  }

  .text.input.item {
    padding: 10px;
  }

  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Vouchers.vue?2109ac13